import gql from 'graphql-tag';

export const getRetailerQL = gql`
  query ($id: ID!) {
    retailer(id: $id) {
      id
      name
      logo(width: 180, height: 120) {
        id
        url
      }
      country
      desId
    }
  }
`;

export const listRetailerQL = gql`
  query ListRetailer($country: String!) {
    retailers: listRetailer(country: $country) {
      id
      name
      logo(width: 200, height: 70) {
        id
        url
      }
      country
      desId
    }
  }
`;
